/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITimelineViewProps } from './timeline';
import { getTimelineItemLabel } from './getTimelineItemLabel';

export default (props: ITimelineViewProps) => {
    return (
        <nav id='timeline' aria-label={props.config.title}>
            <ul>
                <div className='arrow' aria-hidden='true' />
                {props.config.items?.map((menuItem, key) => (
                    <li key={key} onClick={() => (location.href = `#${menuItem.anchor}`)}>
                        {menuItem.image && (
                            <div
                                style={{
                                    backgroundImage: `url(${menuItem.image.src}&w=100&h=100&q=80&m=2&f=jpg)`
                                }}
                            />
                        )}
                        <a href={`#${menuItem.anchor}`} aria-label={getTimelineItemLabel(menuItem.linkText, menuItem.heading)}>
                            {menuItem.heading && (
                                <span className='timeline-item-heading' aria-hidden>
                                    {menuItem.heading}
                                </span>
                            )}
                            <span aria-hidden>{menuItem.linkText}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
